import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Link, NavLink, useLocation, useHistory } from 'react-router-dom';
import * as R from 'ramda';
import $ from 'jquery';

import { GetEtablissementsByPartnerId, GetEtablissementsByPartnerIdDefault } from '../../../../actions/backoffice/partners';

import { EtablissementsTable } from './table';
import { AddPartnerEstablishment } from '../_common/AddPartnerEstablishment';
import { DeletePartnerEstablishment } from '../_common/DeletePartnerEstablishment';

import Establishments from './../../../../assets/images/svg/115-bank.svg';
import Emptylustration from './../../../../assets/images/svg/057-contract-1.svg';
import * as Loadings from '../../../../constants/loadings/backoffice/partners';
import { LoadingState } from '../../../../_common/loadingState';


export const PartnersEstablishment = ({ partner, isLoading, partnerState }) => {
	const dispatch = useDispatch();

	const searchQuery = useLocation();
	const history = useHistory();
	const pageQuery = new URLSearchParams(searchQuery.search);

	let page = pageQuery.get('page');
	let search = pageQuery.get('search');
	let status = pageQuery.get('status');
	let sortBy = pageQuery.get('sortBy');
	let sortDesc = pageQuery.get('sortDesc');
	page = R.isNil(page) ? 1 : parseInt(page);
	search = R.isNil(search) ? "" : search;
	status = R.isNil(status) ? "" : status;
	sortBy = R.isNil(sortBy) ? "creationDate" : sortBy;
	sortDesc = R.isNil(sortDesc) ? "true" : sortDesc;


	const [pageSearch, setPageSearch] = useState(search);
	const renderRef = useRef(false);
	const [selectedEtablissement, setSelectedEtablissement] = useState(undefined);
	const [etablissementStats, setEtablissementStats] = useState({ active: 0, inactive: 0, total: 0 });



	useEffect(() => {
		async function getEtablissementDefault() {
			try {
				const allEtablissement = await GetEtablissementsByPartnerIdDefault(partner.id);
				const totalStatusAmount = allEtablissement.items.reduce((acc, etabliss) => {
					etabliss.isEnabled ? acc.active++ : acc.inactive++;
					return acc;

				}, { active: 0, inactive: 0 });

				setEtablissementStats({ ...totalStatusAmount, total: allEtablissement.items.length });

			} catch (error) {
				throw "Error on loading all the Etablissements ";
			}


		}
		getEtablissementDefault();
	}, [partner.etablissements]);

	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
	}, []);

	useEffect(() => {
		if (isNaN(page) || page === 0) {
			history.push(`backoffice/partners/${partner.id}/etablissements`);
			return;

		}

		//partnerId, pageNumber, searchTerm, isEnabledSearch, sortByTerm, sortDesc
		dispatch(GetEtablissementsByPartnerId(partner.id, page, search, status, sortBy, sortDesc));
	}, [searchQuery.search, history.location]);


	let timer = null;
	useEffect(() => {

		if (!renderRef.current) {
			renderRef.current = true;
			return;
		};

		// if (pageSearch) {
		// 	history.push(`/backoffice/partners/${partner.id}/etablissements?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${status !== "" ? "&status=" + status : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
		// 	return;

		// } else {
		// 	history.push(`/backoffice/partners/${partner.id}/etablissements?page=${1}${status !== "" ? "&status=" + status : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
		// 	return;
		// }

		if (R.isEmpty(pageSearch)) {
			history.push(`/backoffice/partners/${partner.id}/etablissements?page=${1}${status !== "" ? "&status=" + status : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
			return;
		}

		clearTimeout(timer);
		timer = setTimeout(() => {
			dispatch(GetEtablissementsByPartnerId(partner.id, page, search, status, sortBy, sortDesc));
		}, 1000);

		return () => clearTimeout(timer);

		// eslint-disable-next-line 
	}, [pageSearch]);


	const routerQuery = {
		page,
		search,
		sortBy,
		sortDesc,
		status,
	};

	if (partnerState.isLoading.includes(Loadings.FETCHING_ETABLISSEMENTS) && R.isNil(partner.etablissements)) {
		return <LoadingState />;
	}

	if (R.isNil(partner.etablissements)) {
		return (
			<section className="block fs-3 text-center m-auto py-4">
				<img className="img-fluid img-contain container-paper mx-auto mb-4" src={Emptylustration} alt="Assist@" />
				<div className="block text-center container-thin mx-auto">
					<h1 className="font-weight-bolder ls-n2 lh-1">Il n'y a pas d'établissements.</h1>
					<p className="o-80 mb-0">Veuillez ajouter un nouvel établissement.</p>
				</div>
			</section>
		);
	}

	return (
		<article className="view-calc mb-auto pb-sm">
			<div className="container-fluid">
				<header className="rounded-bottom-left-sm rounded-top-right-sm mb-0">
					<h1 className="sr-only visually-hidden">Detail partner</h1>
					<div className="row g-1 align-items-center">
						<div className="col">
							<div className="card p-2 rounded shadow">
								<div className="row align-items-center">
									<div className="col">
										<div className="flex-row my-auto text-truncate align-items-center">
											<div className="rounded-max bg-common d-inherit mr-3 h-6 w-6 text-center">
												<img className="img-fluid m-auto my-3 mb-2 py-1" src={Establishments} alt="Establishments" />
											</div>
											<div className="flex-column">
												<h2 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Nombre total</h2>
												<p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">{etablissementStats.total} Établissement</p>
											</div>
										</div>
									</div>
									<div className="col">
										<h2 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Actifs</h2>
										<p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">{etablissementStats.active}</p>
									</div>
									<div className="col">
										<h2 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Inactifs</h2>
										<p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">{etablissementStats.inactive}</p>
									</div>
								</div>
							</div>
						</div>
						<div className="col col-xl-3">
							<div className="card rounded shadow" role="button" data-toggle="modal" data-target="#AddPartnerEstablishment" onClick={() => setSelectedEtablissement(undefined)}>
								<div className="card-body p-2 media btn-alert my-auto">
									<div className="rounded-max btn-alert-info d-inherit mr-3 h-6 w-6 rounded-max text-center">
										<i className="eva eva-home-outline m-auto fs-4 lh-1" ></i>
									</div>
									<div className="media-body my-auto text-truncate text-info">
										<h2 className="h5 text-uppercase font-weight-bolder my-auto text-truncate">ajouter un <br />nouvel <br />établissement</h2>
									</div>
								</div>
							</div>
							<AddPartnerEstablishment partnerId={partner.id} isLoading={isLoading} selectedEtablissement={selectedEtablissement} />
						</div>
					</div>
				</header>
				<nav className="navbar navbar-expand-sm navbar-light px-0 mb-xl-2 mt-sm mt-xl-0">
					<h1 className="sr-only visually-hidden">Nav</h1>
					<button className="btn-icon btn-alert bg-white navbar-toggler border-0 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
						<span className="btn-alert-primary eva eva-menu-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
						<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Menu</span>
					</button>
					<div className="collapse navbar-collapse flex-column" id="navbarNav">
						<ul className="nav nav-fill nav-pills bg-md-dim rounded-max mt-3">
							<NavLink exact to={`/backoffice/partners/${partner.id}/etablissements`} className="nav-item flex-md-grow-1 text-uppercase rounded-inherit">
								<h2 className="nav-link py-1 px-0 my-auto lh-base">Établissements</h2>
							</NavLink>
							<div className="w-100 mt-1 d-sm-none"></div>
							<NavLink exact to={`/backoffice/partners/${partner.id}/users`} className="nav-item flex-md-grow-1 text-uppercase rounded-inherit">
								<h2 className="nav-link py-1 my-auto lh-base">Utilisateurs</h2>
							</NavLink>
						</ul>
					</div>
				</nav>
			</div>
			<div className="auto-view h-100 mb-auto">
				{/* {R.isNil(partner.etablissements) || partner.etablissements <= 0 ?
					<section className="block fs-3 text-center m-auto py-4">
						<img className="img-fluid img-contain container-paper mx-auto mb-4" src={Emptylustration} alt="Assist@" />
						<div className="block text-center container-thin mx-auto">
							<h1 className="font-weight-bolder ls-n2 lh-1">Il n'y a pas d'établissements.</h1>
							<p className="o-80 mb-0">Veuillez ajouter un nouvel établissement.</p>
						</div>
					</section>
					:
					<EtablissementsTable etablissements={partner.etablissements} partnerState={partnerState} users={partner.users} setSelectedEtablissement={setSelectedEtablissement} pageSearch={pageSearch} setPageSearch={setPageSearch} routerQuery={routerQuery} />
				} */}
				<EtablissementsTable etablissements={partner.etablissements} partnerState={partnerState} users={partner.users} setSelectedEtablissement={setSelectedEtablissement} pageSearch={pageSearch} setPageSearch={setPageSearch} routerQuery={routerQuery} />
			</div>
			<div className="container-fluid">
				<nav className="flex-row my-3 justify-content-center" aria-label="Page navigation">
					{partnerState.etablissementsPagination.currentPage > 1 ? <Link to={`/backoffice/partners/${partner.id}/etablissements?page=${1}${routerQuery.search !== "" ? "&search=" + routerQuery.search : ""}${routerQuery.status !== "" ? "&status=" + routerQuery.status : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i></button>}
					{partnerState.etablissementsPagination.currentPage > 1 ? <Link to={`/backoffice/partners/${partner.id}/etablissements?page=${partnerState.etablissementsPagination.currentPage - 1}${routerQuery.search !== "" ? "&search=" + routerQuery.search : ""}${routerQuery.status !== "" ? "&status=" + routerQuery.status : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i></button>}

					<span className="btn rounded-sm bg-dim px-2 py-1 mx-1 d-flex justify-content-center align-items-center fs-aux">{partnerState.etablissementsPagination.currentPage} de {partnerState.etablissementsPagination.totalPages}</span>

					{partnerState.etablissementsPagination.currentPage < partnerState.etablissementsPagination.totalPages ? <Link to={`/backoffice/partners/${partner.id}/etablissements?page=${partnerState.etablissementsPagination.currentPage + 1}${routerQuery.search !== "" ? "&search=" + routerQuery.search : ""}${routerQuery.status !== "" ? "&status=" + routerQuery.status : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i></button>}
					{partnerState.etablissementsPagination.currentPage < partnerState.etablissementsPagination.totalPages ? <Link to={`/backoffice/partners/${partner.id}/etablissements?page=${partnerState.etablissementsPagination.totalPages}${routerQuery.search !== "" ? "&search=" + routerQuery.search : ""}${routerQuery.status !== "" ? "&status=" + routerQuery.status : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i></button>}
				</nav>
			</div>
			<DeletePartnerEstablishment isLoading={isLoading} selectedEtablissement={selectedEtablissement} />
		</article>
	);
};